import { Modal } from "antd";
import { useParams } from "react-router";
import Error from "../Pages/Error";
import Button from "./Button";
import WishCreateWizard, { useWishCreateWizard } from "./WishCreateWizard";
import { useState } from "react";

interface Props {
  isModalOpen: boolean;
  close: () => void;
}

function makeButtonText(isFinalStep: boolean, isLoading: boolean, parsingDelayed: boolean) {
  if (isFinalStep) {
    return "Save";
  }

  if (isLoading) {
    return parsingDelayed ? "Just a second" : "Analyzing";
  }

  return "Next step";
}

export default function WishCreatePopup({ isModalOpen, close }: Props) {
  const { wishlistId } = useParams();

  const [
    isLoading,
    setIsLoading,
    submitForm,
    cleanup,
    isFinalStep,
    wizardSecrets,
  ] = useWishCreateWizard();

  const [parsingDelayed, setParsingDelayed] = useState(false);

  if (!wishlistId) {
    return <Error message="Wishlist not found" />;
  }

  const handleOk = () => {
    setParsingDelayed(false);
    submitForm();
    if (!isFinalStep) {
      setTimeout(() => {
        setParsingDelayed(true);
      }, 3000);
    }
  };

  const handleCancel = () => {
    setParsingDelayed(false);
    cleanup();
    close();
  };

  const onSubmit = () => {
    setParsingDelayed(false);
    if (isFinalStep) {
      handleCancel();
    }
  };

  const buttonText = makeButtonText(isFinalStep, isLoading, parsingDelayed);

  return (
    <>
      <Modal
        title={<div className="text-center">New Wish</div>}
        footer={
          <div className="flex w-full flex-row">
            <Button key="back" onClick={handleCancel} link className="grow">
              Cancel
            </Button>
            <Button
              key="submit"
              loading={isLoading}
              onClick={handleOk}
              className="grow"
            >
              {buttonText}
            </Button>
          </div>
        }
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width={"fit-content"}
        destroyOnClose={true}
      >
        <WishCreateWizard
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          onSubmit={onSubmit}
          wizardSecrets={wizardSecrets}
        />
      </Modal>
    </>
  );
}
